import { forwardRef, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";

// Stage 5: local replacement for @datasirpi/ui's <EmptyState>. Layout and
// CSS ported letter-for-letter from the vendor's compiled bundle and its
// EmptyState CSS — new .rc-emptystate class names. No enum props here (icon
// and action are arbitrary ReactNode, same as the vendor).
export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  /** d2d-DetectHub eval F16: the title's heading level, so it fits the page's
      outline (an empty state inside a card under an h2 is an h3; one that is
      the page's only content may be an h2). Default 3. */
  headingLevel?: 2 | 3 | 4 | 5 | 6;
}

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(function EmptyState(
  { icon, title, description, action, headingLevel = 3, className, ...rest },
  ref
) {
  const Heading = `h${headingLevel}` as const;
  return (
    <div ref={ref} className={cn("rc-emptystate", className)} {...rest}>
      {icon ? <span className="rc-emptystate__icon">{icon}</span> : null}
      <Heading className="rc-emptystate__title">{title}</Heading>
      {description ? <p className="rc-emptystate__description">{description}</p> : null}
      {action ? <div className="rc-emptystate__action">{action}</div> : null}
    </div>
  );
});
